import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import "../components/css/CustomerAssets.css";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import TicketSidebar from "../components/TicketSidebar";

axios.defaults.withCredentials = true;

const CustomerAssetDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [detail, setDetail] = useState(null);
  const [error, setError] = useState("");
  const [showDeviceHistory, setShowDeviceHistory] = useState(false);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        setError("");

        const res = await axios.get(
          `/api/customer-assets/${id}`,
          {
            withCredentials: true,
          },
        );

        const data = res.data
          ? {
              ...res.data,
              serialChangeLogs: res.data.serialChangeLogs || [],
            }
          : null;

        setDetail(data);
      } catch (err) {
        console.error("fetchDetail error:", err);
        setError(
          err.response?.data?.error ||
            err.message ||
            "ไม่สามารถดึงรายละเอียด asset ได้",
        );
        setDetail(null);
      }
    };

    if (id) {
      fetchDetail();
    }
  }, [id]);

  const formatDate = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleDateString("en-GB");
  };

  return (
    <>
      <Header />

      <div className="ca-layout">
        <div className="ca-sidebar-fixed">
          <TicketSidebar active="/customer/assets-list" />
        </div>

        <div className="ca-page">
          <div className="ca-detail-card">
            <div className="ca-detail-header">
              <h2 className="ca-title">Asset Detail</h2>

              <div className="ca-detail-actions">
                <button
                  className="back-btn"
                  onClick={() => navigate("/customer/assets-list")}
                >
                  Back
                </button>
              </div>
            </div>

            {error && <div className="ca-alert ca-alert-error">{error}</div>}

            {detail && (
              <div className="ca-detail-grid">
                <div className="ca-field">
                  <label>Customer</label>
                  <input type="text" value={detail.customer || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Company</label>
                  <input
                    type="text"
                    value={detail.customer_name || "-"}
                    readOnly
                  />
                </div>

                <div className="ca-field">
                  <label>Phone</label>
                  <input type="text" value={detail.phone || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Email</label>
                  <input type="email" value={detail.email || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Product</label>
                  <input type="text" value={detail.product || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Location</label>
                  <textarea value={detail.location || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Contract Nuumber</label>
                  <input type="text" value={detail.cont_nm || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Type </label>
                  <input type="text" value={detail.cat_type || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Serial</label>
                  <input type="text" value={detail.serial || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>Status</label>
                  <input type="text" value={detail.ma_status || "-"} readOnly />
                </div>

                <div className="ca-field">
                  <label>MA Type</label>
                  <input
                    type="text"
                    value={detail.current_ma_type || "-"}
                    readOnly
                  />
                </div>

                <div className="ca-field">
                  <label>SLA</label>
                  <input
                    type="text"
                    value={detail.current_sla || "-"}
                    readOnly
                  />
                </div>

                <div className="ca-field">
                  <label>Current End Date</label>
                  <input
                    type="text"
                    value={formatDate(detail.current_end_date)}
                    readOnly
                  />
                </div>

                <div className="ca-field">
                  <label>Warranty Remaining:</label>
                  <input
                    type="text"
                    value={detail.coverage_duration || "Warranty Expired"}
                    readOnly
                  />
                </div>
              </div>
            )}

            {detail && (
              <div className="ca-serial-history-card">
                <div className="ca-serial-history-header">
                  <div>
                    <h3>Device History</h3>
                    <p>
                      ประวัติ Serial และการเปลี่ยนอุปกรณ์
                      {detail?.serialChangeLogs?.length > 0
                        ? ` (${detail.serialChangeLogs.length} รายการ)`
                        : ""}
                    </p>
                  </div>

                  <button
                    type="button"
                    className="ca-history-toggle-btn"
                    onClick={() => setShowDeviceHistory((prev) => !prev)}
                  >
                    {showDeviceHistory ? "ซ่อนประวัติ" : "แสดงประวัติ"}
                  </button>
                </div>

                {showDeviceHistory && (
                  <>
                    {detail?.serialChangeLogs?.length > 0 ? (
                      <div className="ca-serial-history-list">
                        {detail.serialChangeLogs.map((log) => {
                          const isInitialImport =
                            log.log_type === "INITIAL_IMPORT";
                          const isAssetInfoUpdated =
                            log.log_type === "ASSET_INFO_UPDATED";
                          const isSerialChangedByTicket =
                            log.log_type === "SERIAL_CHANGED_BY_TICKET";

                          return (
                            <div
                              key={log.id}
                              className="ca-serial-history-item"
                            >
                              <div className="ca-serial-history-main">
                                <strong>
                                  {isInitialImport
                                    ? "Serial เข้าระบบครั้งแรก"
                                    : isAssetInfoUpdated
                                      ? "มีการอัปเดตข้อมูล Asset"
                                      : "มีการเปลี่ยนเครื่อง / เปลี่ยน Serial ใหม่"}
                                </strong>

                                {log.log_serial && (
                                  <span>
                                    Serial:{" "}
                                    <strong className="ca-serial-history-serial">
                                      {log.log_serial}
                                    </strong>
                                  </span>
                                )}
                              </div>

                              <div className="ca-serial-history-detail">
                                {isInitialImport && (
                                  <span>Import เข้าระบบครั้งแรก</span>
                                )}

                                {isAssetInfoUpdated && (
                                  <>
                                    {log.current_ma_type && (
                                      <span>
                                        Current MA Type: {log.current_ma_type}
                                      </span>
                                    )}

                                    {log.current_sla && (
                                      <span>
                                        Current SLA: {log.current_sla}
                                      </span>
                                    )}

                                    {log.current_end_date && (
                                      <span>
                                        Current End Date:{" "}
                                        {formatDate(log.current_end_date)}
                                      </span>
                                    )}
                                  </>
                                )}

                                {isSerialChangedByTicket && (
                                  <>
                                    <span>
                                      Ticket:{" "}
                                      <button
                                        type="button"
                                        className="ca-ticket-link-btn"
                                        onClick={() =>
                                          navigate(
                                            `/customer/ticket/${log.ticket_id}`,
                                          )
                                        }
                                      >
                                        #{log.ticket_id}
                                      </button>
                                    </span>

                                    <span>
                                      Issue: {log.ticket_issue_summary || "-"}
                                    </span>

                                    <span>
                                      Status: {log.ticket_status || "-"}
                                    </span>
                                  </>
                                )}

                                <span>Date: {formatDate(log.created_at)}</span>
                              </div>

                              <p className="ca-serial-history-message">
                                {isInitialImport
                                  ? "ระบบบันทึก Serial นี้จากการเพิ่มข้อมูลอุปกรณ์เข้าระบบครั้งแรก"
                                  : isAssetInfoUpdated
                                    ? "ระบบบันทึกว่ามีการอัปเดตข้อมูลบริการของอุปกรณ์"
                                    : `ระบบบันทึกว่ามีการเปลี่ยนเครื่องหรือเปลี่ยน Serial ใหม่ โดยอ้างอิงจาก Ticket #${log.ticket_id}`}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="ca-serial-history-empty">
                        ยังไม่มีประวัติ Serial
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CustomerAssetDetail;
